import React from "react";
import LazyLoad from "react-lazyload";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="container">
        <div className="footer-links">
          <LazyLoad>
            <div className="social-links">
              <div className="footer-header">Follow us on:</div>
              <div className="social-links-icons">
               
                <a
                  href="https://www.youtube.com/channel/UCIj1yZ44R1-ponVQnObkxSw"
                  className="youtube-icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m23323mt.png"
                    alt="youtube"
                    title="youtube"
                  />
                </a>
                <a
                  href="https://twitter.com/kraftshala"
                  className="twitter-icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m232y42q.png"
                    alt="twiiter"
                    title="twiiter"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/school/kraftshala/"
                  className="linkedin-icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m232fl5g.png"
                    alt="linkedin"
                    title="linkedin"
                  />
                </a>
                <a
                  href="https://www.instagram.com/kraftshala/"
                  className="instagram-icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m232cfvz.png"
                    alt="instagram"
                    title="instagram"
                  />
                </a>
              </div>
            </div>
          </LazyLoad>
          <div className="mob-flex">
            <div className="resources-links">
              <div className="footer-header">Company</div>

              <div className="aboutUs link">
                <a target={"_blank"} href="/about/">About</a>
              </div>
              <div className="alumnies link">
                <a target={"_blank"} href="/kraftshala-careers/">Careers at Kraftshala</a>
              </div>
              <div className="alumnies link">
                <a target={"_blank"} href="/contact-us/">Contact Us</a>
              </div>
              <div className="alumnies link">
                <a target="_blank" href="https://learn.kraftshala.com/#/login">Learn Platform</a>
              </div>
              <div className="alumnies link">
                <a style={{whiteSpace: "nowrap"}} target={"_blank"} href="https://placement-reports.kraftshala.com/">Kraftshala Placements</a>
              </div>
              <div className="alumnies link">
                <a target={"_blank"} href="https://reviews.kraftshala.com/">Alumni</a>
              </div>
              <div className="alumnies link">
                <a target={"_blank"} href="/press-releases/ ">In the Media</a>
              </div>
              {/* <div className="alumnies link">
                <a style={{whiteSpace: "nowrap"}} target={"_blank"} href="/terms-and-conditions/">Terms & Conditions</a>
              </div> */}

              <div className="footer-header inner-header">Partner With Us</div>

              <div className="sl-link link">
                <a target={"_blank"} href="/hire-from-us/">Hire From Us</a>
              </div>
              
            </div>
            <div className="program-links">
              <div className="footer-header">Resources</div>

              <div className="kraftshala-live link">
                <a target={"_blank"} href="/kraftshala-live/">
                  Kraftshala Live
                </a>
              </div>
              <div className="blog link">
                <a target={"_blank"} href="/blog/">Blog</a>
              </div>
              <div className="bb-link link">
                <a target={"_blank"} href="/marketing-glossary/">Marketing Glossary</a>
              </div>
              {/* <div className="kraftshala-live link">
                <a target={"_blank"} href="">Write For Us</a>
              </div> */}
              
              {/* <div className="pbm-link link">
                <a target={"_blank"} href="">Become a Recruiting Partner</a>
              </div> */}
              {/* <div className="mlp-link link">
                <a target={"_blank"} href="">Become an Expert Trainer</a>
              </div> */}
            </div>
          </div>
          <div className="additional-links">
            <div className="footer-header">Marketing Launchpad</div>
            {/* <div className="footer-subheader">Full-time Courses</div> */}
            <div className="learn-link link">
              <a target="_blank" href="/marketing-launchpad/digital-marketing-course/">Digital Marketing Course - Full-time</a>
            </div>
            <div className="learn-link link">
              <a target="_blank" href="/marketing-launchpad/part-time-digital-marketing-course/">
                Digital Marketing Course - Part-time / Weekend{" "}
              </a>
            </div>
            <div className="learn-link link">
              <a target="_blank" href="/marketing-launchpad/digital-marketing-course-in-hindi/">
                Digital Marketing Course in Hindi
              </a>
            </div>

            <div className="footer-header inner-header">
              <a className="footer-header" target="_blank" href="/content-writing-course/">Content Writing & Social Media Launchpad</a>
            </div>

            <div className="footer-header inner-header">
              <a className="footer-header" target="_blank" href="/sales-course/">PGP in Sales, Marketing and Business Leadership</a>
            </div>
            {/* <div className="privacy-pol link">
              <a target={"_blank"} href="/marketing-launchpad/part-time-content-writing-and-social-media-marketing-course/">
                Part-time Content Writing & Social Media Marketing Course
              </a>
            </div> */}
          </div>

        </div>
        <hr className="footer-hr" />
        <div className="popular-resource">
          Popular Resources
        </div>
        <div className="extended-data">
          <div className="link-footer">
            <a target={"_blank"} href="/blog/which-digital-marketing-specialization-should-i-choose/">Which Digital Marketing Specialization for you?</a>
          </div>

          {/* <div className="divider">|</div>
          <div className="link-footer"><a target={"_blank"} href="/blog/benefits-of-pay-after-placement-courses/">Benefits of pay-after-placement</a></div> */}
          <div className="divider">|</div>
          <div className="link-footer"><a target={"_blank"} href="/blog/types-of-digital-marketing-fields/">Types of Digital Marketing Fields</a></div>
          <div className="divider">|</div>
          <div className="link-footer"><a target={"_blank"} href="/blog/how-to-crack-kraftshala-screening-test/">Kraftshala Screening Test</a></div>
          <div className="divider">|</div>
          <div className="link-footer"><a target={"_blank"} href="/blog/should-i-take-up-a-part-time-digital-marketing-course/">Why choose a part-time course?</a></div>
          <div className="divider">|</div>
          <div className="link-footer"><a target={"_blank"} href="/blog/how-to-make-a-cv/">CV Making Guide</a></div>
          <div className="divider">|</div>
          <div className="link-footer">
            <a target={"_blank"} href="/blog/how-to-become-a-digital-marketer/">Complete Guide to Cracking Your First Digital Marketing Job</a>
          </div>
          <div className="divider">|</div>
          <div className="link-footer">
            <a target={"_blank"} href="/blog/how-to-become-a-social-media-manager/">How to Grab Your First Social Media Marketing Job?</a>
          </div>
          <div className="my-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
